module.exports = __webpack_public_path__ + "img/icon-rooms.3e5b4c74.svg";